import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';

import {Observable} from 'rxjs';

import * as fromAfbGraphqlApi from '../../afb-graphql-api/reducers';
import {select, Store} from '@ngrx/store';
import {map} from 'rxjs/operators';
import {Logout} from '../../afb-graphql-api/actions/auth.actions';

@Injectable()
export class CreateOrganizationGuard implements CanActivate {

  constructor(private afbGraphqlApiStore: Store<fromAfbGraphqlApi.State>) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.afbGraphqlApiStore.pipe(
      select(fromAfbGraphqlApi.isLoginLoaded),
      map((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          return true;
        } else {
          this.afbGraphqlApiStore.dispatch(new Logout());
          return false;
        }
      })
    );
  }
}
